var map = {
	"./Xrobotmon CRK intro images.pptx": "7093",
	"./cken1.jpeg": "e3c6",
	"./cken2.jpeg": "2752",
	"./cken3.jpeg": "4329",
	"./cken4.jpeg": "d02f",
	"./ckja1.jpeg": "b879",
	"./ckja2.jpeg": "bd8d",
	"./ckja3.jpeg": "61bf",
	"./ckja4.jpeg": "39c0",
	"./ckko1.jpeg": "b822",
	"./ckko2.jpeg": "d157",
	"./ckko3.jpeg": "d3eb",
	"./ckko4.jpeg": "17e5",
	"./cktw1.jpeg": "f802",
	"./cktw2.jpeg": "10f7",
	"./cktw3.jpeg": "9a8c",
	"./cktw4.jpeg": "b3e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad2d";